import { render, staticRenderFns } from "./PanThumb.vue?vue&type=template&id=5d8628f7&scoped=true&"
import script from "./PanThumb.vue?vue&type=script&lang=js&"
export * from "./PanThumb.vue?vue&type=script&lang=js&"
import style0 from "./PanThumb.vue?vue&type=style&index=0&id=5d8628f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8628f7",
  null
  
)

export default component.exports